export const outlineConfig = {
    selectionLayer: 10,
    visibleEdgeColor: 0xffffff,
    edgeStrength: 5,
    pulseSpeed: 0,
    hiddenEdgeColor: 0x22090a,
    blur: 2,
    xRay: true,
}